import { createContext, useContext } from 'react';

export const CRTrackerContext = createContext();
export const useCRTrackerContext = () => useContext(CRTrackerContext);
